export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  TAG_PAGE: "tag-page",
  AUTHOR_PAGE : "author-page",
  SEARCH_PAGE: "search-page",
  STORY_PAGE: "story-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview-page",
  HOME_PREVIEW: "home-preview-page",
  STATIC_PAGE: "static-page"
});

export const WHITELIST_CONFIG_KEYS = ['cdn-image', 'sketches-host', 'polltype-host', 'publisher-name', 'publisher-id', 'env', 'publisher-settings', 'social-links', 'static-pages', 'layout', 'sections'];
